var _rect, _rect2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.05957,
    y: 0.674805,
    width: 24.8042,
    height: 16.1189,
    rx: 2.5,
    stroke: "#888B94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2559,
    y: 5.20605,
    width: 24.8042,
    height: 16.1189,
    rx: 2.5,
    fill: "white",
    stroke: "#888B94"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6577,
    cy: 13.2656,
    r: 2.8042,
    stroke: "#888B94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.36cab710ab78bd785f9322e25895cc5d.svg";
export { ForwardRef as ReactComponent };